<template>
  <div class="detail-steps">
    <half-page :visible.sync="visible" :title="stepTitle" @onClose="onClose">
      <div slot="body" class="detail-steps__content">
        <div
          v-for="(item, index) in imgList"
          class="detail-steps__content__item"
          :key="index"
        >
          <img-container :img="item.img" :text="item.text" :number="index" />
        </div>
      </div>
    </half-page>
  </div>
</template>
<script>
import ImgContainer from '../../components/ImgContainer.vue';
import HalfPage from '../../components/HalfPage.vue';
export default {
  components: {
    ImgContainer,
    HalfPage
  },
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    stepTitle: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('onClose');
    }
  }
};
</script>
<style scoped lang="less">
.detail-steps {
  &__content {
    margin: 0.5rem auto;
    display: flex;
    overflow: scroll;
    &__item:first-child {
      /deep/.img-container__index {
        &::before {
          display: none;
        }
      }
    }
    &__item:last-child {
      /deep/.img-container__index {
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
